import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const RESULTS_MODIFIED_AT_QUERY: DocumentNode = gql`
  query ResultsModifiedAtQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: LAB_AUTOMATION) {
    results(ids: $ids) {
      ... on ResultNode {
        id
        modifiedAt
        createdAt
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
